interface Props {
  label: string;
  active?: boolean;
  onClick?: () => void;
}

export default function Pill({ label, active, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      type="button"
      style={{
        padding: '8px 18px',
        borderRadius: 6,
        border: active ? 'none' : '1px solid #333',
        background: active ? 'var(--accent)' : 'transparent',
        color: active ? '#0f0f0f' : '#b8b4af',
        fontFamily: 'inherit',
        fontSize: 13,
        fontWeight: active ? 600 : 400,
        cursor: 'pointer',
        transition: 'all 0.15s',
        whiteSpace: 'nowrap',
      }}
    >
      {label}
    </button>
  );
}
